import Text from "../../Components/Text";
import SubscriptionInfo from "../../Components/SubscriptionInfo";
import SubscriptionTable from "../../Components/SubcriptionTable";

const ExpiredOwner = () => {
    return (
        <div className="w-full h-full bg-white flex justify-center overflow-hidden">
            <div className="w-full h-full flex flex-col p-3 gap-3 overflow-y-auto">

                {/* Header */}
                <div className="w-full flex flex-col p-3">
                    <Text type="maintitle" classNames="text-center">
                        Das Workspace-Abonnement ist derzeit inaktiv.
                    </Text>
                    <Text type="itemtext" classNames="text-center">
                        Wähle das Abonnement welches am ehesten zu deinem Geschäft passt
                    </Text>
                </div>

                <SubscriptionInfo />
                <SubscriptionTable />
            </div>
        </div>
    );
};

export default ExpiredOwner;
